import { Typography } from 'components';

import styles from './ResourcesEmptyState.module.css';

// Title + subtitle per Figma; shown in either section when filters match nothing.
const TITLE = 'No matches found.';
const DESCRIPTION = 'Try adjusting your filters to expand the search.';

// Shared by both the webinars and the guides sections when active filters match
// nothing.
export const ResourcesEmptyState = () => (
  <div className={styles.emptyState}>
    <Typography variant='heading-m'>{TITLE}</Typography>
    <Typography variant='body-s' color='grey'>
      {DESCRIPTION}
    </Typography>
  </div>
);
